// extracted by mini-css-extract-plugin
export default {"button":"BtyqQ","icon":"Vq4Bh"};